module.exports = __webpack_public_path__ + "media/images/emblems/Orpund-coat_of_arms-91103e5d30174619bc680d06bdd388df.svg";